import { FIELD } from "./action";

const initialState = {
  fieldList: [],
  fieldCreated: {},
  selectedField: {},
  fieldUpdated: {}
};

export default function fieldReducer(state = initialState, action) {
  switch (action.type) {
    case FIELD.list.success:
      return {
        ...state,
        fieldList: action.data,
        fieldCreated: {},
        fieldUpdated: {}
      };
    case FIELD.create.success:
      return {
        ...state,
        fieldCreated: action.data
      };
    case FIELD.edit.success:
      return {
        ...state,
        selectedField: action.data
      };
    case FIELD.update.success:
      return {
        ...state,
        fieldUpdated: action.data
      };
    case FIELD.delete.success:
      const fieldId = action.data.id;
      return {
        ...state,
        fieldList: state.fieldList.filter(field => field.id !== fieldId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/fields/reducer.js